import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Button, Form, Row, Col, Card } from 'react-bootstrap';
import ParameterTabs from '../../Components/ParameterTabs/ParameterTabs';
import FileNameModal from '../../Components/FileNameModal/FileNameModal';
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from '../../authConfig';
import { PageLayout } from '../../Components/PageLayout/PageLayout';
import { DataPullerService } from '../../Services/DataPullerService';
import SelectPipelineModal from '../../Components/SelectPipelineModal/SelectPipelineModal';
import { useNavigate } from 'react-router-dom';
import { PageLayout2 } from '../../Components/PageLayout/PageLayout2';
import InformationModal from '../../Components/InformationModal/InformationModal';
import ConfirmationModal from '../../Components/ConfirmationModal/ConfirmationModal';

const NewTaskPageContent = () => {
    const { instance, accounts, inProgress } = useMsal();
    const [parameterGroups, setParameterGroups] = useState([]);
    const [selectedValues, setSelectedValues] = useState({});
    const [selectedPipeline, setSelectedPipeline] = useState(null);
    const [showFileNameModal, setShowFileNameModal] = useState(false);
    const [showPipelineModal, setShowPipelineModal] = useState(true);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [activeKey, setActiveKey] = useState(0);
    const [parameterOptions, setParameterOptions] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        if(selectedPipeline) fetchParameterGroups();
    }, [selectedPipeline]);

    useEffect(() => {
        // Initialize parameter options for all parameters
        parameterGroups.forEach(group => {
            group.parameters.forEach(param => {
                fetchParameterValues(param.id, Object.keys(selectedValues).map(key => ({
                    name: key,
                    values: selectedValues[key]
                })));
            });
        });
    }, [parameterGroups]);

    const handleTabSelect = (k) => {
        setActiveKey(parseInt(k));
    };

    const handleSaveAndContinue = () => {
        
        if (activeKey < parameterGroups.length - 1) {
            setActiveKey(activeKey + 1);
        } else {
            handleSaveParameters();
        }
    };

    const handleBack = () => {
        if (activeKey > 0) {
            setActiveKey(activeKey - 1);
        }
    };

    const fetchParameterValues = async (parameterId, relatedParameterValues) => {
        try {
            const request = {
                ...loginRequest,
                account: accounts[0]
            };
            const response = await instance.acquireTokenSilent(request);

            const data = await DataPullerService.getParameterValues(parameterId, relatedParameterValues, response.accessToken);
            setParameterOptions(prevOptions => ({
                ...prevOptions,
                [parameterId]: data
            }));
        } catch (error) {
            console.error('Failed to fetch parameter values:', error);
        }
    };

    const handleValueChange = (parameter, value) => {
        const newSelectedValues = { ...selectedValues };

        if (!newSelectedValues[parameter.name]) {
            newSelectedValues[parameter.name] = [];
        }

        // Se presionó el checkbox para "All"
        if (value === '-1') {
            // El checkbox ya estaba seleccionado, se quiere quitar la seleccion
            if (newSelectedValues[parameter.name].includes('-1')) {
                newSelectedValues[parameter.name] = [];
            } 
            // El checkbox no estaba seleccionado, se hace la seleccion
            else {
                newSelectedValues[parameter.name] = ['-1'];
            }
        } 
        // Se presiono cualquier otro checkbox que no sea "All"
        else {
            // Verificar si ya se habia seleccionado "All anteriormente"
            if (newSelectedValues[parameter.name].includes('-1')) {
                // Seleccionar individualmente todas las opciones
                newSelectedValues[parameter.name] = parameterOptions[parameter.id].map(option => option.id)
            }

            // Si el valor ya se encuentra entre los valores seleccionados eleminarlo. Ya sea porque se habia
            // seleccionado anteriormente de forma manual o porque estaba seleccionada la opcion "All"
            if (newSelectedValues[parameter.name].includes(value)) {
                newSelectedValues[parameter.name] = newSelectedValues[parameter.name].filter(v => v !== value);
            } 
            // De lo contario, simplemente agregar el valor a la lista
            else {
                newSelectedValues[parameter.name].push(value);
            }

            // Si con la seleccion que se hizo, se han seleccionado todos los elementos, quitar la lista de
            // valores individuales y reemplazarla por el "-1" que representa a "All"
            if (newSelectedValues[parameter.name].length === parameterOptions[parameter.id].length) {
                // newSelectedValues[parameter.name] = ['-1', ...newSelectedValues[parameter.name]];
                newSelectedValues[parameter.name] = ['-1'];
            }
        }

        setSelectedValues(newSelectedValues);

        // Update related parameters' options
        parameterGroups.forEach(group => {
            group.parameters.forEach(param => {
                if (param.relatedParameters && param.relatedParameters.includes(parameter.name)) {
                    fetchParameterValues(param.id, Object.keys(newSelectedValues).map(key => ({
                        name: key,
                        values: newSelectedValues[key]
                    })));
                }
            });
        });
    };

    const fetchParameterGroups = async () => {
        try {
            const request = {
                ...loginRequest,
                account: accounts[0]
            };
            const response = await instance.acquireTokenSilent(request);

            const data = await DataPullerService.getParameterGroups(selectedPipeline, response.accessToken);
            // if(data) {
            //     // Initialize selected values for all parameters with "-1"
            //     const initialSelectedValues = {};
            //     data.forEach(group => {
            //         group.parameters.forEach(param => {
            //             initialSelectedValues[param.name] = ['-1'];
            //         });
            //     });
            //     setSelectedValues(initialSelectedValues);
            // }
            setParameterGroups(data);
        } catch (error) {
            console.error('Failed to fetch parameter groups:', error);
        }
    };

    const handlePipelineSelect = async (pipelineId) => {
        try {
            // const data = await DataPullerService.getParameterGroups(pipelineId);
            setSelectedPipeline(pipelineId);
            // setParameterGroups(data);
            setShowPipelineModal(false);
        } catch (error) {
            console.error('Failed to fetch parameter groups:', error);
        }
    };

    const handleSaveParameters = () => {
        setShowFileNameModal(true);
    };

    const handleFileNameSubmit = async (fileName) => {
        try {
            const request = {
                ...loginRequest,
                account: accounts[0]
            };
            const response = await instance.acquireTokenSilent(request);

            const result = DataPullerService.executeTask({
                TaskName: fileName,
                PipelineId: parseInt(selectedPipeline),
                Parameters: Object.entries(selectedValues).map(([Name, Values]) => ({ Name, Values }))
            }, response.accessToken);
            // window.location.href = '/data-extraction';

            navigate('/data-extraction');
            // if(result && result.status == 200){
            //     navigate('/data-extraction');
            // }else if(result && result.status == 400){
            //     setShowErrorModal(true)
            // }
        } catch (error) {
            console.error('Failed to create task:', error);
        }
    };

    const handleCancel = () => {
        setShowConfirmationModal(true);
    }

    const handleConfirmBack = () => {
        navigate('/data-extraction');
    }

    const handleCloseErrorModal = () => {
        setShowErrorModal(false);
        navigate('/data-extraction');
    }

    return (
        <Container fluid className='d-flex flex-column flex-grow-1 h-100 NewTaskPage p-4 justify-content-stretch'>
            {/* <Row>
                <Col className='text-left'>
                    <h5 className='mb-0'>New Data Selector Task</h5>
                </Col>
            </Row> */}
            <ParameterTabs 
                parameterGroups={parameterGroups} 
                selectedValues={selectedValues} 
                setSelectedValues={setSelectedValues} 
                onSave={handleSaveParameters}
                activeKey={activeKey}
                handleTabSelect={handleTabSelect}
                handleValueChange={handleValueChange}
                parameterOptions={parameterOptions}
            />
            <div className='w-100 d-flex justify-content-between'>
                <Button onClick={handleCancel} variant='outline-dark' size='lg' className="">
                    Cancel
                </Button>
                <div className=''>
                    <Button onClick={handleBack} variant='secondary' size='lg' className='me-4'>
                        Previous
                    </Button>
                    <Button onClick={handleSaveAndContinue} variant='primary' size='lg' className="">
                        {activeKey < parameterGroups.length - 1 ? 'Next' : 'Finish'}
                    </Button>
                </div>
            </div>
            <FileNameModal 
                show={showFileNameModal} 
                onHide={() => setShowFileNameModal(false)} 
                onSubmit={handleFileNameSubmit}
            />
            <SelectPipelineModal 
                show={showPipelineModal} 
                onPipelineSelect={handlePipelineSelect}
            />
            <InformationModal 
                show={showErrorModal}
                onAcceptClick={handleCloseErrorModal}
                onHide={handleCloseErrorModal}
                title="Error running task"
                content="An error ocurred processing the data extraction request. Plese check the task's details for more information."
            />
            <ConfirmationModal 
                show={showConfirmationModal}
                onAcceptClick={handleConfirmBack}
                onCancelClick={() => setShowConfirmationModal(false)}
                onHide={() => setShowConfirmationModal(false)}
                title="Exit Selector"
                content="You are about to exit this page. Your current parameter selection will be lost. Do you want to exit?"
            />
        </Container>
    );
};

const NewTaskPage = () => {
    return (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <PageLayout2 title="New Data Selector Task">
                <NewTaskPageContent />

            </PageLayout2>
        </MsalAuthenticationTemplate>
    )
}

export default NewTaskPage;
